export class GetRestoreAccountConnectivityConfigResponse {
    'restoreAccountConfig';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "restoreAccountConfig",
            "baseName": "restoreAccountConfig",
            "type": "RestoreAccountConnectivityConfig",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GetRestoreAccountConnectivityConfigResponse.attributeTypeMap;
    }
    constructor() {
    }
}
